var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"button is-outlined",attrs:{"disabled":_vm.item.isDisabled},on:{"click":function($event){return _vm.startCaseAction()}}},[_vm._v("\n    Start reporting case\n")])}
var staticRenderFns = []

export { render, staticRenderFns }